import { render, staticRenderFns } from "./CharacteristicsModal.vue?vue&type=template&id=0fb0efc6&scoped=true&"
import script from "./CharacteristicsModal.vue?vue&type=script&lang=js&"
export * from "./CharacteristicsModal.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicsModal.vue?vue&type=style&index=0&id=0fb0efc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb0efc6",
  null
  
)

export default component.exports